import { balanceFor, monthPeriod } from '@apka/core'
import type { PaymentView } from '@apka/core'
import { useEffect, useState } from 'react'
import { MIESIACE_SKROT } from './format.js'
import { zl } from './format.js'
import './wykresy.css'

interface Props {
  widoki: readonly PaymentView[]
  rok: number
  wybranyMiesiac: number
}

/**
 * Dwanaście słupków roku. Zapłacone rysujemy pełnym akcentem, planowane
 * przygaszonym — od razu widać, gdzie kończy się historia, a zaczyna plan.
 */
export function WykresTrendu({ widoki, rok, wybranyMiesiac }: Props) {
  // Słupki wyrastają od podstawy, kolumna po kolumnie — rok czyta się wtedy
  // jak przebieg w czasie, a nie jak statyczna tabelka.
  const [wyrosniete, ustawWyrosniete] = useState(false)
  useEffect(() => {
    const klatka = requestAnimationFrame(() => ustawWyrosniete(true))
    return () => cancelAnimationFrame(klatka)
  }, [])

  const miesiace = Array.from({ length: 12 }, (_, indeks) => {
    const okres = monthPeriod(rok, indeks + 1)
    const wydatki = widoki.filter(
      (widok) =>
        widok.type === 'expense' &&
        widok.status !== 'skipped' &&
        widok.dueDate >= okres.from &&
        widok.dueDate <= okres.to,
    )
    const zaplacone = wydatki
      .filter((widok) => widok.status === 'paid')
      .reduce((suma, widok) => suma + widok.amountPlnMinor, 0)
    const planowane = wydatki
      .filter((widok) => widok.status !== 'paid')
      .reduce((suma, widok) => suma + widok.amountPlnMinor, 0)
    return { miesiac: indeks + 1, zaplacone, planowane, razem: zaplacone + planowane }
  })

  const szczyt = Math.max(...miesiace.map((wpis) => wpis.razem), 1)
  const opis = miesiace
    .map((wpis) => `${MIESIACE_SKROT[wpis.miesiac - 1]}: ${zl(wpis.razem)}`)
    .join(', ')

  return (
    <div className="wykres-trendu" role="img" aria-label={`Wydatki w roku ${rok}. ${opis}`}>
      {miesiace.map((wpis) => (
        <div
          key={wpis.miesiac}
          className={
            wpis.miesiac === wybranyMiesiac
              ? 'wykres-trendu__kolumna wykres-trendu__kolumna--wybrana'
              : 'wykres-trendu__kolumna'
          }
        >
          <div className="wykres-trendu__slupek">
            <span
              className="wykres-trendu__planowane"
              style={{
                height: wyrosniete ? `${(wpis.planowane / szczyt) * 100}%` : '0%',
                transitionDelay: `${wpis.miesiac * 34}ms`,
              }}
            />
            <span
              className="wykres-trendu__zaplacone"
              style={{
                height: wyrosniete ? `${(wpis.zaplacone / szczyt) * 100}%` : '0%',
                transitionDelay: `${wpis.miesiac * 34}ms`,
              }}
            />
          </div>
          <span className="wykres-trendu__etykieta">{MIESIACE_SKROT[wpis.miesiac - 1]}</span>
        </div>
      ))}
    </div>
  )
}
